
import type { SaveData } from '@/domains/onboarding/types';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import type { OnboardingService } from '../onboarding-service';
import { OnboardingApiService } from '../../apis/onboarding-api';

@injectable()
export class OnboardingServiceImpl implements OnboardingService {
    constructor(
        @inject(OnboardingApiService) private onboardingApiService: OnboardingApiService
    ) {
    }

    save(data: SaveData) {
        return this.onboardingApiService.save(data);
    }

    info() {
        return this.onboardingApiService.info();
    }
}
